import { PERMISSION_ENDPOINT_URI, TERMS_V2_ENABLED, USER_ENDPOINT_URI } from 'constants/Constants';
import axios from 'axios';
import {
    CLEAR_REPORT_DATA,
    FETCH_AGREEMENTS,
    LOAD_TERMS_CONDITIONS,
    SIGNED_AGREEMENT,
    SET_LOGGEDIN_USER,
    FETCH_AGREEMENTS_SIGNED_LOADED,
    TOGGLE_TERMS,
    SHOW_DANGER_BAR
} from './types';
import publicIP from 'react-native-public-ip';
import moment from 'moment';
import {
    COULD_NOT_FETCH_SIGNED_TERMS,
    COULD_NOT_SAVE_AGREEMENT,
    COULD_NOT_FETCH_TERMS
} from '../../constants/Constants';

const getAccessTokenHeader = () =>
    TERMS_V2_ENABLED
        ? {
              headers: {
                  Authorization: `Bearer ${sessionStorage.getItem('access_token')}`
              }
          }
        : {};

const showErrorMessage = (dispatch, message) => {
    return () => {
        dispatch({
            type: SHOW_DANGER_BAR,
            payload: message
        });
    };
};

const mapV2SignedTermstoTermsV1 = (agreement) => {
    if (TERMS_V2_ENABLED) {
        return {
            user_id: agreement.userId,
            user_name: agreement.userName,
            email: agreement.email,
            application_id: agreement.applicationId,
            account_id: agreement.accountId,
            account_name: agreement.accountName,
            ip_address: agreement.ipAddress,
            version_id: agreement.termsId,
            is_agreed: agreement.isAgreed,
            agreed_on: agreement.agreedOn,
            version: agreement.version,
            signed_on: agreement.signedOn
        };
    }
    return agreement;
};

const mapV2TermsToTermsV1 = async (terms) => {
    if (TERMS_V2_ENABLED) {
        const termsCopy = { ...terms };
        termsCopy.data = {
            version: terms.data.version,
            application_id: terms.data.applicationId,
            terms: terms.data.terms,
            creator_id: terms.data.creatorId,
            created_at: terms.data.createdAt
        };
        return termsCopy;
    } else {
        return terms;
    }
};

const mapV1SignedTermsToV2 = (signedTerms) =>
    TERMS_V2_ENABLED ? { ipAddress: signedTerms.ip_address } : signedTerms;

const mapV2SignedTermsResponseToV1 = async (agreements) => {
    const agreementCopy = { ...agreements };
    agreementCopy.data = agreements.data.map((agreement) => mapV2SignedTermstoTermsV1(agreement));
    return agreementCopy;
};

export const getAllSignedAgreements = (accountId) => (dispatch) => {
    const agreementsUrl = TERMS_V2_ENABLED
        ? `https://${USER_ENDPOINT_URI}/iam/v2/terms/trustcenter/users/signedTerms/account/${accountId}`
        : `https://${USER_ENDPOINT_URI}/api/v1/trustcenter/terms/signed/account/${accountId}`;

    dispatch({
        type: FETCH_AGREEMENTS_SIGNED_LOADED,
        payload: false
    });
    axios
        .get(agreementsUrl, getAccessTokenHeader())
        .then((agreements) => mapV2SignedTermsResponseToV1(agreements))
        .then((agreements) => {
            dispatch({
                type: FETCH_AGREEMENTS,
                signedAgreements: agreements
            });
        })
        .catch(showErrorMessage(dispatch, COULD_NOT_FETCH_SIGNED_TERMS))
        .finally(() => {
            dispatch({
                type: FETCH_AGREEMENTS_SIGNED_LOADED,
                payload: true
            });
        });
};

export const revertFlag = (data) => (dispatch) => {
    dispatch({
        type: FETCH_AGREEMENTS_SIGNED_LOADED,
        payload: data
    });
};

export const clearReportData = () => {
    return {
        type: CLEAR_REPORT_DATA,
        payload: {}
    };
};

export const signAgreement = (signedTermsAndConditions) => (dispatch) => {
    const termsUrl = TERMS_V2_ENABLED
        ? `https://${USER_ENDPOINT_URI}/iam/v2/terms/trustcenter/users/signedTerms`
        : `https://${USER_ENDPOINT_URI}/api/v1/trustcenter/terms/signed`;

    axios
        .post(termsUrl, mapV1SignedTermsToV2(signedTermsAndConditions), getAccessTokenHeader())
        .then(async (term) => ({ ...term, data: mapV2SignedTermstoTermsV1(term.data) }))
        .then((signedAgreement) => {
            dispatch({
                type: SIGNED_AGREEMENT,
                signedAgreement: signedAgreement.data
            });
        })
        .catch(showErrorMessage(dispatch, COULD_NOT_SAVE_AGREEMENT));
};

export const toggleTerms = (value) => (dispatch) => {
    dispatch({
        type: TOGGLE_TERMS,
        payload: value
    });
};

export const getTerms = () => (dispatch) => {
    const termsUrl = TERMS_V2_ENABLED
        ? `https://${USER_ENDPOINT_URI}/iam/v2/terms/trustcenter`
        : `https://${USER_ENDPOINT_URI}/api/v1/trustcenter/terms`;

    axios
        .get(termsUrl, getAccessTokenHeader())
        .then((terms) => mapV2TermsToTermsV1(terms))
        .then((terms) => {
            const notifyEndTime = moment(moment(terms.data.created_at).add(30, 'days')).endOf(
                'day'
            );
            const currentTime = moment();
            let notify = false;
            if (notifyEndTime - currentTime > 0) {
                notify = true;
            }
            dispatch({
                type: LOAD_TERMS_CONDITIONS,
                termsAndConditions: terms.data,
                termsNotify: notify
            });
        })
        .catch(showErrorMessage(dispatch, COULD_NOT_FETCH_TERMS));
};

export const setLoggedInUser = (accountId, userId, userUUID, accountName) => (dispatch) => {
    let userIpAddress;
    publicIP().then((ip) => {
        userIpAddress = ip;
    });
    const permissionUrl = `https://${PERMISSION_ENDPOINT_URI}/api/v1/trustcenter/user/${userUUID}/permissions`;
    const termsUrl = TERMS_V2_ENABLED
        ? `https://${USER_ENDPOINT_URI}/iam/v2/terms/trustcenter/users/signedTerms`
        : `https://${USER_ENDPOINT_URI}/api/v1/trustcenter/terms/signed/account/${accountId}/${userId}`;

    const loadSignedTerms = (trustCenterReadWritePermission) => {
        axios
            .get(termsUrl, getAccessTokenHeader())
            .then(async (term) => ({ ...term, data: mapV2SignedTermstoTermsV1(term.data) }))
            .then((termsResponse) => {
                dispatch({
                    type: SET_LOGGEDIN_USER,
                    loggedInUserTCPermission: trustCenterReadWritePermission,
                    loggedInUserTerms: termsResponse.data,
                    loggedInUserAccountName: accountName,
                    userIpAddress: userIpAddress
                });
            })
            .catch(showErrorMessage(dispatch, COULD_NOT_FETCH_SIGNED_TERMS));
    };

    axios
        .get(permissionUrl, {
            params: { upstream_url: '/api/v1/trustcenter', serviceName: 'Trust Center' }
        })
        .then((permResponse) => {
            const trustCenterReadWritePermission =
                permResponse.data.write !== undefined
                    ? permResponse.data.write || permResponse.data.read
                    : false;
            loadSignedTerms(trustCenterReadWritePermission);
        })
        .catch((error) => {
            // Without a catch, Trust Center API 4xx/5xx become uncaught CRA overlays.
            // Continue with no TC permission so signed-terms (and dashboard routing) can still load.
            console.warn('[Dashboard access] trustcenter user/permissions failed; continuing', {
                status: error?.response?.status,
                url: error?.config?.url,
                data: error?.response?.data,
                userUUID
            });
            loadSignedTerms(false);
        });
};
